export class HelpText {

  helpTextId: number;
  appKey: string;
  pageKey: string;
  htmlContent: string;
  deleted: boolean;

  public constructor(entity?: Partial<HelpText>) {
    Object.assign(this, entity);
  }
}
